import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {

    private _count = 0;

    private _isLoading$ = new BehaviorSubject<boolean>(false);
    isLoading$ = this._isLoading$.asObservable();

    private _title$ = new BehaviorSubject<string>('Loading');
    private _subtitle$ = new BehaviorSubject<string | null>(null);
    private _isDefault$ = new BehaviorSubject<boolean>(true);

    title$ = this._title$.asObservable();
    subtitle$ = this._subtitle$.asObservable();
    isDefault$ = this._isDefault$.asObservable();

    show(title?: string, subtitle?: string) {
        this._count++;

        if (this._count === 1) {
            const isDefault = !title && !subtitle;

            this._isDefault$.next(isDefault);
            this._title$.next(title || 'Loading');
            this._subtitle$.next(subtitle || null);
            this._isLoading$.next(true);
        }
    }

    hide() {
        if (this._count > 0) {
            this._count--;
        }

        if (this._count === 0) {
            this._isLoading$.next(false);
            this._subtitle$.next(null);
            this._isDefault$.next(true);
        }
    }

    reset() {
        this._count = 0;
        this._isLoading$.next(false);
        this._isDefault$.next(true);
        this._title$.next('Loading');
        this._subtitle$.next(null);
    }
}
